import React, { useEffect } from "react";
import Layout from "@/HOC";
import { Breadcrumb, Spin } from "antd";
import { CloseCircleTwoTone } from "@ant-design/icons";
import { useRouter } from "next/router";
import { getPaymentStatus } from "@/utils/apis/payment/payment-status.api";
import { isNotSSR } from "@/utils/common";
import Link from "next/link";
import { useAppContext } from "@/context";
import Cookies from "js-cookie";
import Head from "next/head";
import DefaultSeo from "@/component/seo/DefaultSeo";

function PaymentFailed() {
  const router = useRouter();
  const currentPageName = router.pathname.replace(/^\//, "").replace(/-/g, " ");
  const formattedPageName =
    currentPageName.charAt(0).toUpperCase() + currentPageName.slice(1);
  const { user } = useAppContext();

  const paymentId = router.query.session_id as string;
  const planId = router.query.plan as string;

  const handlePaymentStatus = async () => {
    if (!paymentId || !planId || !isNotSSR) return;
    const accessToken = Cookies.get("x-access") || null;
    const res = await getPaymentStatus(paymentId, accessToken, planId);
    console.log(res);
    router.replace("/my-plan");
  };

  useEffect(() => {
    handlePaymentStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNotSSR, paymentId, planId]);

  return (
    <div>
      <DefaultSeo
        title="Payment Failed"
        description="Your payment failed. Redirecting to subscription page..."
      />
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
        />
      </Head>
      <Layout>
        <div className="Breadcrumb">
          <div className="main">
            <Breadcrumb
              items={[
                {
                  title: (
                    <Link href={user ? "/dashboard" : "/home"}>
                      {user ? "Dashboard" : "Home"}
                    </Link>
                  ),
                },
                {
                  title: "Payment Failed",
                },
              ]}
            />
          </div>
        </div>
        <div className="main">
          <div className="PaymentMain">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  background: "#fff",
                  width: 400,
                  height: 300,
                  borderRadius: 18,
                  boxShadow: "3px 5px 13px #ddd",
                  display: "flex",
                  flexDirection: "column",
                  gap: 16,
                }}
              >
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 100,
                    marginTop: 40,
                  }}
                >
                  <div
                    style={{
                      background: "#D74848",
                      width: 100,
                      height: 100,
                      position: "absolute",
                      zIndex: 1,
                      borderRadius: 50,
                      opacity: 0.3,
                    }}
                  />
                  <div
                    style={{
                      background: "#D74848",
                      width: 80,
                      height: 80,
                      zIndex: 2,
                      position: "absolute",
                      borderRadius: 40,
                      opacity: 0.5,
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      zIndex: 3,
                      background: "#fff",
                      width: 60,
                      height: 60,
                      borderRadius: 30,
                    }}
                  >
                    <CloseCircleTwoTone
                      style={{
                        fontSize: 60,
                      }}
                      twoToneColor="#D74848"
                    />
                    {/* <Succesc color={"#27AE60"} size={60} /> */}
                  </div>
                </div>
                <span
                  style={{
                    fontSize: 30,
                    alignSelf: "center",
                    margin: "20px 0px 0px 0px",
                    fontWeight: "bold",
                  }}
                >
                  Payment Failed
                </span>

                <div
                  style={{
                    fontSize: 16,
                    alignSelf: "center",
                    fontFamily: "sans-serif",
                    display: "flex",
                    alignItems: "center",
                    gap: "1rem",
                    margin: "1rem 0 0 0",
                  }}
                >
                  <span>Redirecting to subscription page...</span>
                  <Spin />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
}

export default PaymentFailed;
